import React, { useMemo } from 'react';
import clsx from 'clsx';
import MMSConnected from '../../sf-components/Icons/MMS_online.tsx';
import CMSConnected from '../../sf-components/Icons/CMS_online.tsx';
import CMSOffline from '../../sf-components/Icons/CMS_offline.tsx';
import MMSOffline from '../../sf-components/Icons/MMS_offline.tsx';
import { Tooltip } from '@material-ui/core';

export function MmsCmsConnectivityStatus({
    name,
    offlineMode,
    isActive,
    showText = true,
    showTooltip = false,
    className = ''
}) {
    const isMMS = useMemo(() => name === 'MMS', [name]);

    const Icon = useMemo(() => {
        if (offlineMode) {
            return isMMS ? MMSOffline : CMSOffline;
        }
        if (isActive) {
            return isMMS ? MMSConnected : CMSConnected;
        }

        return isMMS ? MMSOffline : CMSOffline;
    }, [isActive, isMMS, offlineMode]);

    const iconColor = useMemo(() => {
        if (offlineMode) {
            return '#A5A5A5';
        }
        if (isActive) {
            return '#188DED';
        }
        return '#F7B748';
    }, [isActive, offlineMode]);

    const statusText = useMemo(() => {
        if (offlineMode) {
            return 'Offline';
        }
        return isActive ? 'Connected' : 'Not Connected';
    }, [isActive, offlineMode]);

    const fullName = useMemo(() => (isMMS ? 'Mobile Messaging Service' : 'Cloud Messaging Service'), [isMMS]);

    const textColor = useMemo(() => {
        if (offlineMode) {
            return 'text-sf-gray-400';
        }
        return isActive ? 'text-sf-positive-500' : 'text-sf-gray-400';
    }, [isActive, offlineMode]);

    if (!Icon || !statusText) {
        return null;
    }

    return (
        <Tooltip title={showTooltip && `${fullName} ${statusText}`} disableHoverListener={!showTooltip}>
            <div
                className={clsx(
                    'status flex items-start mr-2 mt-1 items-center',
                    isActive && !offlineMode ? 'active' : 'nonactive',
                    className
                )}>
                <Icon fillColor={iconColor} />
                {showText && (
                    <div className="flex flex-wrap items-center max-w-[115px] mr-2 ml-1">
                        <span className="text-sf-gray-500">
                            {fullName} <span className={clsx(textColor)}>{statusText}</span>
                        </span>
                    </div>
                )}
            </div>
        </Tooltip>
    );
}
